import React, { Component } from 'react'
import Education from './Education'
import Experiencie from './Experiencie'

export default class RigthColumn extends Component {
    render() {
        return (
            <div className="w3-twothird">
               <Experiencie/> 
               <Education/>
            </div>
        )
    }
}
